import { Component, OnInit, Input } from '@angular/core';
import { ACCESS_TYPE } from '../../configs/enums/access-type.enum';
import { HealthSherpaSSOService } from '../../services/health-sherpa-sso.service';

@Component({
    selector: 'app-health-sherpa-sso',
    templateUrl: './health-sherpa-sso.component.html',
    styleUrls: ['./health-sherpa-sso.component.scss'],
    standalone: false
})
export class HealthSherpaSSOComponent implements OnInit {
  @Input() healthSherpaLabel: string;

  constructor(
    private healthSherpaSSOService: HealthSherpaSSOService
  ) {}

  ngOnInit(): void {}

  async submitSSOForm() {
    const passedPreSSOValidation: boolean = await this.healthSherpaSSOService.doSSO(ACCESS_TYPE.NEW_QUOTE);
  }
}

